export default __webpack_public_path__ + "static/media/product-2.51acda9f.jpg";